import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useAdsterIdentity from 'src/hooks/useAdsterIdentity';
import { cleanTargeting, getUserAdTargeting } from 'src/services/adsterTargeting';
// App.js owns SDK loading. Placements only use its initialized instance.
let refreshTimer;
function refreshAdsterSlots(sdk) {
  clearTimeout(refreshTimer);
  refreshTimer = setTimeout(() => {
    Promise.resolve().then(() => sdk.handleRouteChange()).catch((error) =>
      console.warn('Adster slot refresh failed:', error));
  }, 0);
}

function TargetedSlot({ id, identity, targeting, includePpid, ...props }) {
  const [sdk, setSdk] = useState(null);
  useEffect(() => {
    let cancelled = false;
    let instance;
    const applyTargeting = async () => {
      if (!window.adsterSdk) return;
      try {
        const userTargeting = await getUserAdTargeting(identity, includePpid);
        if (cancelled) return;
        instance = window.adsterSdk;
        const slotTargeting = identity === 'null' ? {} : cleanTargeting({
          ...userTargeting, ...JSON.parse(targeting),
        });
        instance.setSlotTargeting(id, slotTargeting);
        console.log('[Adster SDK]', {
          id,
          loggedIn: identity !== 'null',
          targeting: slotTargeting,
          targetingStatus: Object.keys(slotTargeting).length ? 'set' : 'empty: no valid logged-in targeting values',
        });
        setSdk(instance);
      } catch (error) {
        console.warn('Adster targeting unavailable:', error);
      }
    };
    window.addEventListener('adster-sdk-ready', applyTargeting);
    applyTargeting();
    return () => {
      cancelled = true;
      window.removeEventListener('adster-sdk-ready', applyTargeting);
      instance?.setSlotTargeting(id, {});
    };
  }, [id, identity, targeting, includePpid]);

  useEffect(() => {
    if (sdk) refreshAdsterSlots(sdk);
  }, [sdk]);

  // Targeting is ready before the SDK can observe this container in the DOM.
  return sdk ? <div {...props} id={id} /> : null;
}

export default function AdsterSlot({ id, targeting = {}, includePpid = true, ...props }) {
  const identity = useAdsterIdentity();
  const location = useLocation();
  const values = JSON.stringify(cleanTargeting(targeting));
  // Remount when targeting changes so an existing ad cannot request with old values.
  const key = JSON.stringify([id, identity, values, includePpid, location.pathname, location.search]);
  return <TargetedSlot key={key} id={id} identity={identity} targeting={values}
    includePpid={includePpid} {...props} />;
}
